var _excluded = ["children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useFocusRing } from '@react-aria/focus';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import React from 'react';
import { StyledSwitchContainer, StyledSwitchLabel, StyledToggle, StyledTrack } from './Switch.styles';
/**

 We use switches to allow users to choose between two mutually exclusive choices
 in the same line. This is often associated with enabling vs. disabling.

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-switch--demo)

 @see [Design Guidelines](https://design.procore.com/switch)

 */
export var Switch = /*#__PURE__*/React.forwardRef(function Switch(_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFocusRing = useFocusRing(),
    isFocusVisible = _useFocusRing.isFocusVisible,
    focusProps = _useFocusRing.focusProps;
  return /*#__PURE__*/React.createElement(StyledSwitchContainer, {
    $focused: isFocusVisible,
    $disabled: props.disabled,
    $checked: props.checked
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement("input", _extends({
    ref: ref
  }, props, focusProps, {
    "aria-checked": props.checked,
    role: "switch",
    type: "checkbox"
  }))), /*#__PURE__*/React.createElement(StyledTrack, null, /*#__PURE__*/React.createElement(StyledToggle, null)), children && /*#__PURE__*/React.createElement(StyledSwitchLabel, null, children));
});
Switch.displayName = 'Switch';
//# sourceMappingURL=Switch.js.map